module.exports = __webpack_public_path__ + "static/media/014.ec31ddac.png";